import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b1247aa&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=4b1247aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1247aa",
  null
  
)

export default component.exports